import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { ContentBlockWarningsItem } from '@nucleus-commerce/api-client/admin';
import { Alert, AlertDescription, AlertTitle } from '@nucleus-commerce/ui/components/alert';

/** Broken references the backend found on read: a deleted image, a hidden collection, an unpublished product. */
export function BlockWarnings({
  warnings,
  tour,
}: {
  warnings: readonly ContentBlockWarningsItem[];
  tour?: string;
}) {
  const { t } = useTranslation('content');
  if (warnings.length === 0) return null;
  return (
    <Alert role="status" data-tour={tour}>
      <AlertTriangle aria-hidden />
      <AlertTitle>{t('warnings.title', { count: warnings.length })}</AlertTitle>
      <AlertDescription>
        <ul className="list-disc pl-4">
          {warnings.map((warning, index) => (
            <li key={`${warning.path}-${index}`}>
              {t(`warnings.${warning.code}`)}{' '}
              <code className="text-muted-foreground text-xs">{warning.path}</code>
            </li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  );
}
